import { render, staticRenderFns } from "./MonoImport.vue?vue&type=template&id=47956319&scoped=true"
import script from "./MonoImport.vue?vue&type=script&lang=js"
export * from "./MonoImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47956319",
  null
  
)

export default component.exports